/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_SearchingInputs */

const cs_ruian_searching = /** @type {(inputs: Ruian_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledám…`)
};

const en_ruian_searching = /** @type {(inputs: Ruian_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching…`)
};

/**
* | output |
* | --- |
* | "Searching…" |
*
* @param {Ruian_SearchingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_searching = /** @type {((inputs?: Ruian_SearchingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_SearchingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_searching(inputs)
	return cs_ruian_searching(inputs)
});